/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssessmentAiModel } from './AssessmentAiModel';
import {
  AssessmentAiModelFromJSON,
  AssessmentAiModelFromJSONTyped,
  AssessmentAiModelToJSON,
} from './AssessmentAiModel';
import type { DatasetPipelineShallow } from './DatasetPipelineShallow';
import {
  DatasetPipelineShallowFromJSON,
  DatasetPipelineShallowFromJSONTyped,
  DatasetPipelineShallowToJSON,
} from './DatasetPipelineShallow';

/**
 * Representation of assessment including status, runtime, progress and Risk Indicator when
 * assessment is complete
 * @export
 * @interface Assessment
 */
export interface Assessment {
  /**
   *
   * @type {number}
   * @memberof Assessment
   */
  readonly id: number;
  /**
   *
   * @type {number}
   * @memberof Assessment
   */
  questionnaireAnswer: number;
  /**
   *
   * @type {Array<number>}
   * @memberof Assessment
   */
  riskMetrics?: Array<number>;
  /**
   *
   * @type {boolean}
   * @memberof Assessment
   */
  quick?: boolean;
  /**
   *
   * @type {number}
   * @memberof Assessment
   */
  riskIndicator?: number | null;
  /**
   * The timestamp when the assessment was created.
   * @type {Date}
   * @memberof Assessment
   */
  readonly timestamp: Date;
  /**
   * The current status of the assessment.
   * @type {string}
   * @memberof Assessment
   */
  readonly status: string;
  /**
   * The current progress of the assessment.
   * @type {number}
   * @memberof Assessment
   */
  readonly progress: number;
  /**
   * The start time of the assessment.
   * @type {Date}
   * @memberof Assessment
   */
  readonly startTime: Date | null;
  /**
   * The end time of the assessment.
   * @type {Date}
   * @memberof Assessment
   */
  readonly endTime: Date | null;
  /**
   * The estimated time for the assessment to complete.
   * @type {string}
   * @memberof Assessment
   */
  readonly estimatedTime: string;
  /**
   *
   * @type {string}
   * @memberof Assessment
   */
  comment?: string;
  /**
   * The elapsed time since the assessment started.
   * @type {string}
   * @memberof Assessment
   */
  readonly elapsedTime: string;
  /**
   * The AI model associated with the questionnaire answer.
   * @type {AssessmentAiModel}
   * @memberof Assessment
   */
  readonly aiModel: AssessmentAiModel;
  /**
   *
   * @type {DatasetPipelineShallow}
   * @memberof Assessment
   */
  readonly datasetPipeline: DatasetPipelineShallow;
}

/**
 * Check if a given object implements the Assessment interface.
 */
export function instanceOfAssessment(value: object): value is Assessment {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('questionnaireAnswer' in value) || value['questionnaireAnswer'] === undefined) return false;
  if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
  if (!('status' in value) || value['status'] === undefined) return false;
  if (!('progress' in value) || value['progress'] === undefined) return false;
  if (!('startTime' in value) || value['startTime'] === undefined) return false;
  if (!('endTime' in value) || value['endTime'] === undefined) return false;
  if (!('estimatedTime' in value) || value['estimatedTime'] === undefined) return false;
  if (!('elapsedTime' in value) || value['elapsedTime'] === undefined) return false;
  if (!('aiModel' in value) || value['aiModel'] === undefined) return false;
  if (!('datasetPipeline' in value) || value['datasetPipeline'] === undefined) return false;
  return true;
}

export function AssessmentFromJSON(json: any): Assessment {
  return AssessmentFromJSONTyped(json, false);
}

export function AssessmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Assessment {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    questionnaireAnswer: json['questionnaire_answer'],
    riskMetrics: json['risk_metrics'] == null ? undefined : json['risk_metrics'],
    quick: json['quick'] == null ? undefined : json['quick'],
    riskIndicator: json['risk_indicator'] == null ? undefined : json['risk_indicator'],
    timestamp: new Date(json['timestamp']),
    status: json['status'],
    progress: json['progress'],
    startTime: json['start_time'] == null ? null : new Date(json['start_time']),
    endTime: json['end_time'] == null ? null : new Date(json['end_time']),
    estimatedTime: json['estimated_time'],
    comment: json['comment'] == null ? undefined : json['comment'],
    elapsedTime: json['elapsed_time'],
    aiModel: AssessmentAiModelFromJSON(json['ai_model']),
    datasetPipeline: DatasetPipelineShallowFromJSON(json['dataset_pipeline']),
  };
}

export function AssessmentToJSON(
  value?: Omit<
    Assessment,
    | 'id'
    | 'timestamp'
    | 'status'
    | 'progress'
    | 'startTime'
    | 'endTime'
    | 'estimatedTime'
    | 'elapsedTime'
    | 'aiModel'
    | 'datasetPipeline'
  > | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    questionnaire_answer: value['questionnaireAnswer'],
    risk_metrics: value['riskMetrics'],
    quick: value['quick'],
    risk_indicator: value['riskIndicator'],
    comment: value['comment'],
  };
}
